'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachmentUploadProgress = undefined;

var _reduxActions = require('redux-actions');

var _fileUploadsActionTypes = require('../constants/fileUploadsActionTypes');

var attachmentUploadProgress = exports.attachmentUploadProgress = (0, _reduxActions.createAction)(_fileUploadsActionTypes.ATTACHMENT_UPLOAD_PROGRESS);


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/attachmentUploadProgress.js
// module id = 563
// module chunks = 2 3